/*
 * @Author: 欧阳铭山
 * @Date: 2022-06-23 10:54:46
 * @LastEditors: 方宾菲
 * @LastEditTime: 2025-04-15 10:01:36
 * @Description: Description
 * @FilePath: \ys.gnss\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("components/Home.vue"),
    children: [
      {
        path: "yzt",
        name: "一张图",
        component: () => import("components/yzt/YztView.vue"),
      },
      {
        path: "bgsc",
        name: "报告生成",
        component: () => import("components/sjfx/SjfxView.vue"),
        children: [
          {
            path: "/sjfx/jyldb",
            name: "降雨量对比",
            component: () => import("components/sjfx/jyldb/JyldbView.vue"),
          },
          {
            path: "/sjfx/ybjc",
            name: "预报检测",
            component: () => import("components/sjfx/ybjc/YbjcView.vue"),
          },
          {
            path: "/sjfx/bgsc",
            name: "报告生成",
            component: () => import("components/sjfx/bgsc/BgscView.vue"),
          },
        ],
      },
      {
        path: "wlw",
        name: "物联网",
        component: () => import("components/wlw/WlwView.vue"),
        children: [
          {
            path: "/wlw/sbgl",
            name: "设备管理",
            component: () => import("components/wlw/sbgl/components/EquipmentManagement.vue"),
          },
          {
            path: "/wlw/sbzgl",
            name: "设备组管理",
            component: () => import("components/wlw/sbzgl/SbzglView.vue"),
          },
        ],
      },
      {
        path: "ssgc",
        name: "实施过程",
        component: () => import("components/ssgc/SsgcView.vue"),
        children: [
          {
            path: "/ssgc/xmgl",
            name: "项目管理",
            component: () => import("components/ssgc/xmgl/XmglView.vue"),
          },
          {
            path: "/ssgc/tkxz",
            name: "踏勘选址",
            component: () => import("components/ssgc/tkxz/TkxzView.vue"),
          },
          {
            path: "/ssgc/jdgl",
            name: "进度管理",
            component: () => import("components/ssgc/jdgl/JdglView.vue"),
          },
        ],
      },
      {
        path: "ywgl",
        name: "运维管理",
        component: () => import("components/ywgl/YwglView.vue"),
        children: [
          {
            path: "/ywgl/sbbx",
            name: "设备报修",
            component: () => import("components/ywgl/sbbx/SbbxView.vue"),
          },
          {
            path: "/ywgl/ycsbjk",
            name: "异常设备监控",
            component: () => import("components/ywgl/ycsbjk/YcsbjkView.vue"),
          },
          {
            path: "/ywgl/ywgd",
            name: "运维工单",
            component: () => import("components/ywgl/ywgd/YwgdView.vue"),
          },
          {
            path: "/ywgl/ywrysz",
            name: "运维人员设置",
            component: () => import("components/ywgl/ywrysz/YwryszView.vue"),
          },
          {
            path: "/ywgl/ycjcplsz",
            name: "异常监测频率设置",
            component: () => import("components/ywgl/ycjcplsz/YcjcplszView.vue"),
          },
        ],
      },
      {
        path: "xjgl",
        name: "巡检管理",
        component: () => import("components/xjgl/XjglView.vue"),
        children: [
          {
            path: "/xjgl/xjrw",
            name: "巡检任务",
            component: () => import("components/xjgl/xjrw/XjrwView.vue"),
          },
        ],
      },
      {
        path: "/",
        name: "实施过程",
        component: () => import("components/xtgl/XtglView.vue"),
        children: [


          {
            //'组织机构分类',
            name: 'xtgl-zzjgfl',
            path: 'yhxxgl/zzjgfl',
            component: () => import('@/components/xtgl/zzjgfl/ZzjgflView.vue')
          },
          {
            //'组织机构管理',
            name: 'xtgl-zzjggl',
            path: 'yhxxgl/zzjggl',
            component: () => import('@/components/xtgl/zzjggl/ZzjgglView.vue')
          },
          {
            //'用户管理',
            name: 'xtgl-yhgl',
            path: 'yhxxgl/yhgl',
            component: () => import('@/components/xtgl/yhgl/YhglView.vue')
          },
          {
            //'角色分类',
            name: 'xtgl-jsfl',
            path: 'jsyqxgl/jsfl',
            component: () => import('@/components/xtgl/jsfl/JsflView.vue')
          },
          {
            //'角色管理',
            name: 'xtgl-jsgl',
            path: 'jsyqxgl/jsgl',
            component: () => import('@/components/xtgl/jsgl/JsglView.vue')
          },
          {
            //'管辖区授权管理',
            name: 'xtgl-gxqsqgl',
            path: 'jsyqxgl/gxqsqgl',
            component: () => import('@/components/xtgl/gxqsqgl/GxqsqglView.vue')
          },
          {
            //'业务系统注册',
            name: 'xtgl-ywxtzc',
            path: 'yyxtgl/ywxtzc',
            component: () => import('@/components/xtgl/ywxtzc/YwxtzcView.vue')
          },
          {
            //'功能模块分类',
            component: () =>
              import('@/components/xtgl/gnmkfl/GnmkflView.vue'),
            name: 'xtgl-gnmkfl',
            path: 'yyxtgl/gnmkfl'
          },
          {
            //'功能模块管理',
            name: 'xtgl-gnmkgl',
            path: 'yyxtgl/gnmkgl',
            component: () => import('@/components/xtgl/gnmkgl/GnmkglView.vue')
          },
          {
            //'菜单管理',
            name: 'xtgl-cdgl',
            path: 'yyxtgl/cdgl',
            component: () => import('@/components/xtgl/cdgl/CdglView.vue')
          },
          {
            //'行政区管理',
            name: 'xtgl-xzqgl',
            path: 'pzgl/xzqgl',
            component: () => import('@/components/xtgl/xzqgl/XzqglView.vue')
          },
          {
            //'管辖区管理',
            name: 'xtgl-gxqgl',
            path: 'pzgl/gxqgl',
            component: () => import('@/components/xtgl/gxqgl/GxqglView.vue')
          },
          {
            //'预警签名配置',
            name: 'xtgl-yjqmpz',
            path: 'pzgl/yjqmpz',
            component: () => import('@/components/xtgl/yjqmpz/YjqmpzView.vue')
          },
          {
            //'登录退出日志',
            name: 'xtgl-dlczrz',
            path: 'xtrz/dltcrz',
            component: () => import('@/components/xtgl/dltcrz/DltcrzView.vue')
          },
          {
            //'操作日志',
            name: 'xtgl-czrz',
            path: 'xtrz/czrz',
            component: () => import('@/components/xtgl/czrz/CzrzView.vue')
          },
          {
            //'施工阶段配置',
            name: 'xtgl-sgjdpz',
            path: 'xtgl/sgjdpz',
            component: () => import('@/components/xtgl/sgjdpz/SgjdpzView.vue')
          },
          {
            //'施工阶段配置',
            name: 'xtgl-sblxpz',
            path: 'xtgl/sblxpz',
            component: () => import('@/components/xtgl/sblxpz/SblxpzView')
          },
          {
            path: 'xtgl-appgl',   //app管理
            name: 'xtgl-appgl',
            component: () => import('@/components/xtgl/appgl/AppglView.vue'),
            children: []
          },
        ]
      },
      {
        path: "sjfx",
        name: "数据分析",
        component: () => import("components/sjfx/sjfx/SjfxView.vue"),
      },
      {
        path: "sbzl",
        name: "设备总览",
        component: () => import("components/sbzl/SbzlView.vue"),
      },
    ]
  },
  {
    path: "/login",
    name: "登录",
    component: () => import("components/login/LoginView.vue"),
  },
];

const router = new VueRouter({ routes });

// 旧
router.beforeEach((to, from, next) => {
  const token = store.state.user.token;
  if (!token && to.name !== "登录") {
    //判断系统是否存在token
    next({ path: "/login" });
  } else {
    next();
  }
});

export default router;
